import React from 'react'

import Image from 'next/image'
import { IoIosClose } from 'react-icons/io'

import { Flex, HStack, IconButton } from '@chakra-ui/react'

interface SelectedImagesPreviewIProps {
  removeFile: (file: File) => void
  selectedFiles: File[]
}

interface ImageThumbnailWrapperIProps {
  file: File
  removeFile: (file: File) => void
}

const ImageThumbnail = ({ imgUrl }: { imgUrl: string }) => {
  return (
    <Image
      alt='Image'
      className='rounded-md'
      height={50}
      src={imgUrl}
      style={{
        maxWidth: '100%',
        height: '100%',
        objectFit: 'cover',
      }}
      width={50}
    />
  )
}

const ImageThumbnailWrapper = ({
  file,
  removeFile,
}: ImageThumbnailWrapperIProps) => {
  const handleRemoveFile = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    e.stopPropagation()
    removeFile(file)
  }

  return (
    <Flex
      alignItems='center'
      height='12'
      justifyContent='center'
      mt='2'
      position='relative'
    >
      <IconButton
        aria-label='Remove'
        backgroundColor='gray.200'
        onClick={handleRemoveFile}
        position='absolute'
        right='-2.5'
        rounded='full'
        size='2xs'
        top='-2.5'
      >
        <IoIosClose size={20} />
      </IconButton>
      <ImageThumbnail imgUrl={URL.createObjectURL(file)} />
    </Flex>
  )
}

export const SelectedImagesPreview = ({
  removeFile,
  selectedFiles,
}: SelectedImagesPreviewIProps) => {
  return (
    <HStack
      data-testid='createIncidentModal_selectedImagesPreview'
      gap={3}
      mt={3}
    >
      {selectedFiles.map((file: File) => (
        <Flex
          alignContent='center'
          flexDirection='column'
          key={file.name}
          position='relative'
        >
          <ImageThumbnailWrapper file={file} removeFile={removeFile} />
        </Flex>
      ))}
    </HStack>
  )
}
